import { Routes } from '@angular/router';
import { UserRoleType } from 'BaseDataTypes';
import { AgreementViewComponent } from 'projects/Assets/src/assets-base/Pages/agreement-view/agreement-view.component';
import { ClientViewComponent } from 'projects/Assets/src/assets-base/Pages/client-view/client-view.component';
import { ComponentViewComponent } from 'projects/Assets/src/assets-base/Pages/component-view/component-view.component';
import { FeatureViewComponent } from 'projects/Assets/src/assets-base/Pages/feature-view/feature-view.component';
import { JobViewComponent } from 'projects/Assets/src/assets-base/Pages/job-view/job-view.component';
import { PlantViewComponent } from 'projects/Assets/src/assets-base/Pages/plant-view/plant-view.component';
import { authGuard } from 'src/app/auth.guard';
const AssetsRouteConfig: Routes = [
  { path: '', redirectTo: 'Kunder', pathMatch: 'full' },
  {
    path: 'Kunder',
    title: 'Kunder',
    component: ClientViewComponent,
    canActivate: [authGuard],
    data: {
      allowedUserRoleType: [
        UserRoleType.Admin,
        UserRoleType.Manager,
        UserRoleType.User,
      ],
    },
  },
  {
    path: 'aftaler',
    title: 'Aftaler',
    component: AgreementViewComponent,
    canActivate: [authGuard],
    data: {
      allowedUserRoleType: [
        UserRoleType.Admin,
        UserRoleType.Manager,
        UserRoleType.User,
      ],
    },
  },
  {
    path: 'componenter',
    title: 'Komponenter',
    component: ComponentViewComponent,
    canActivate: [authGuard],
    data: {
      allowedUserRoleType: [
        UserRoleType.Admin,
        UserRoleType.Manager,
        UserRoleType.User,
      ],
    },
  },
  {
    path: 'features',
    title: 'Features',
    component: FeatureViewComponent,
    canActivate: [authGuard],
    data: {
      allowedUserRoleType: [
        UserRoleType.Admin,
        UserRoleType.Manager,
        UserRoleType.User,
      ],
    },
  },
  {
    path: 'anlæg',
    title: 'Anlæg',
    component: PlantViewComponent,
    canActivate: [authGuard],
    data: {
      allowedUserRoleType: [
        UserRoleType.Admin,
        UserRoleType.Manager,
        UserRoleType.User,
      ],
    },
  },
  {
    path: 'jobs',
    title: 'Jobs',
    component: JobViewComponent,
    canActivate: [authGuard],
    data: {
      allowedUserRoleType: [
        UserRoleType.Admin,
        UserRoleType.Manager,
        UserRoleType.User,
      ],
    },
  },
];

export default AssetsRouteConfig;
